import { SVGProps } from "react";

const FacebookSocialIcon = ({
  className,
  ...props
}: SVGProps<SVGSVGElement> & { className?: string }) => (
  <svg
    width="11"
    height="18"
    viewBox="0 0 11 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden={true}
    {...props}
  >
    <path
      d="M8.09642 0C5.46842 0 3.92708 1.33843 3.92708 4.38814V7.07143H0.59375V10.2857H3.92708V18H7.26042V10.2857H9.92708L10.5938 7.07143H7.26042V4.932C7.26042 3.78321 7.64908 3.21429 8.76708 3.21429H10.5938V0.131786C10.2778 0.0906428 9.35708 0 8.09642 0Z"
      fill="#36332F"
    />
  </svg>
);

export default FacebookSocialIcon;
